import React, { useEffect, useState } from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";

const TABLE_URL = process.env.REACT_APP_LEAGUE_TABLE_URL || (import.meta && import.meta.env && import.meta.env.REACT_APP_LEAGUE_TABLE_URL) || "";
const SCHEDULE_URL = process.env.REACT_APP_LEAGUE_SCHEDULE_URL || (import.meta && import.meta.env && import.meta.env.REACT_APP_LEAGUE_SCHEDULE_URL) || "";

export default function Liga() {
  const [tab, setTab] = useState("tabelle");

  const Frame = ({ src, testid }) => (
    <div className="rounded-xl overflow-hidden border border-white/10 bg-[#130a0d]">
      <iframe
        title={testid}
        data-testid={testid}
        src={src}
        className="w-full h-[70vh]"
        sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
      />
      <div className="p-3 text-xs text-rose-200/80 flex items-center justify-between">
        <span>Falls die Einbettung blockiert ist, öffne den Link im neuen Tab.</span>
        <a href={src} target="_blank" rel="noreferrer" className="underline" data-testid={`${testid}-open`}>
          In neuem Tab öffnen
        </a>
      </div>
    </div>
  );

  return (
    <div className="pb-28 min-h-screen bg-[#0e0b0c] text-rose-50 px-4 pt-6">
      <h2 className="text-xl font-bold mb-4">Liga – RheinStars Köln 5</h2>
      <Tabs value={tab} onValueChange={setTab} data-testid="liga-tabs">
        <TabsList className="mb-4">
          <TabsTrigger value="tabelle" data-testid="liga-tab-tabelle">Tabelle</TabsTrigger>
          <TabsTrigger value="spielplan" data-testid="liga-tab-spielplan">Spielplan</TabsTrigger>
        </TabsList>
        <TabsContent value="tabelle">
          <Frame src={TABLE_URL} testid="liga-iframe-tabelle" />
        </TabsContent>
        <TabsContent value="spielplan">
          <Frame src={SCHEDULE_URL} testid="liga-iframe-spielplan" />
        </TabsContent>
      </Tabs>
    </div>
  );
}
